import * as React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { TCheckboxGroupFilter } from './CheckboxGroupFilter.types';
import './CheckboxGroupFilter.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const CheckboxGroupFilter: TCheckboxGroupFilter = ({
  options,
  onChange,
  defaultValue = [],
}) => {
  const localize = useLocalize();
  const [selectedOptions, setSelectedOptions] = React.useState<string[]>(
    defaultValue || []
  );

  const checkboxLabelNode = (title: string) => (
    <p className="caption font-semibold">{localize(title)}</p>
  );

  return (
    <FormGroup className="checkbox-group-filter">
      {options.map((option) => (
        <FormControlLabel
          key={option.id}
          control={<Checkbox className="checkbox-group-filter__checkbox" />}
          label={checkboxLabelNode(option.label)}
          checked={selectedOptions.includes(option.id)}
          onChange={(event) => {
            const isChecked = (
              event.target as EventTarget & { checked: boolean }
            ).checked;
            if (isChecked) {
              setSelectedOptions((previousOptions) => {
                const newOptions = [...previousOptions, option.id];
                onChange(newOptions);
                return newOptions;
              });
            } else {
              setSelectedOptions((previousOptions) => {
                const newOptions = previousOptions.filter(
                  (id) => id !== option.id
                );

                onChange(newOptions);
                return newOptions;
              });
            }
          }}
        />
      ))}
    </FormGroup>
  );
};
